import { UserOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { memo } from "react";
import "./CustomerCell.scss";

export type CustomerCellProps = {
  customer?: { name?: string; staff?: { name?: string; username?: string } | null } | null;
  href?: string;
};

// Cột "Khách hàng": dòng 1 = tên khách (đậm), dòng 2 = nhãn bo tròn nhân viên phụ trách (xanh; xám nếu chưa có)
export const CustomerCell = memo(({ customer, href }: CustomerCellProps) => {
  if (!customer) {
    return <span className="tableCustomerCell__empty">--</span>;
  }

  const staffName = customer.staff?.name || customer.staff?.username || "";
  const name = <div className="tableCustomerCell__name">{customer.name || "--"}</div>;

  return (
    <div className="tableCustomerCell">
      <Tooltip title={customer.name} mouseEnterDelay={0.4}>
        {href ? (
          <a
            className="activityLogCustomerLink"
            href={href}
            target="_blank"
            rel="noreferrer"
            onClick={(event) => event.stopPropagation()}
          >
            {name}
          </a>
        ) : (
          name
        )}
      </Tooltip>
      <Tooltip title={staffName ? `Sale phụ trách: ${staffName}` : undefined} mouseEnterDelay={0.4}>
        <span className={staffName ? "tableCustomerCell__staff" : "tableCustomerCell__staff tableCustomerCell__staff--none"}>
          <UserOutlined />
          <span className="tableCustomerCell__staffName">{staffName || "Chưa có sale"}</span>
        </span>
      </Tooltip>
    </div>
  );
});

CustomerCell.displayName = "CustomerCell";
